<template>
	<div>
		<a-row>
				<a-row class="banner-title">
					<a-col :span="20"><h3>商会动态列表</h3></a-col>
					<a-col :span="4" style="padding-bottom: 15px;" ><a-button type="danger"  icon="plus-square" @click="showAddStyleModal">发布动态</a-button></a-col>
				</a-row>
				<!-- <a-card hoverable style="width: 300px;float: left; margin: 10px;" :key="index"  v-for="(item,index) in dynamicList">
					<img
					alt="example"
					:src="item.img[0]"
					slot="cover"
					/>
					<template class="ant-card-actions" slot="actions">
						<a-icon type="edit"  @click="showCommodityModal"/>
						<a-icon type="delete" @click="deleteDynamic(item.id)"/>
						<a-icon type="ellipsis" />
					</template>
					<a-card-meta :title="item.title"  :description="item.intro">
						<a-avatar
						slot="avatar"
						:src="item.cover[0]"
						/>
					</a-card-meta>
				</a-card> -->
		</a-row>
		
		<a-list style="width: 1000px;" item-layout="vertical" size="large" :pagination="pagination" :data-source="dynamicList">
			<div slot="footer">
				<b>帝全</b>
				商会动态
			</div>
			<a-list-item slot="renderItem" :key="item.title" slot-scope="item, index">
				<template slot="actions">
					<a-popconfirm title="将删除该条商会动态,是否删除？" @confirm="deleteDynamic(item.id)" @cancel="cancel" okText="删除" cancelText="取消">
						<a-button type="danger" size="small">删除</a-button>
					</a-popconfirm>
					<span>{{ item.addTime }}</span>
				</template>
		
				<img 
				style="max-width: 100px; max-height: 100px;"
		    slot="extra"
		    width="272"
		    alt="logo"
		    :src="item.cover[0]"
		  />
				<a-list-item-meta description="">
					<a slot="title">{{ item.title }}</a>
					<a-avatar slot="avatar" src="http://cdn.diqwl.com/store_banner_inform3.png" />
				</a-list-item-meta>
				{{ item.intro }}
			</a-list-item>
		</a-list>
		
		<a-modal width="840px" :title="menu" :visible="addCompanyStyleWindow" :confirmLoading="addCompanyStyleLoading" @cancel="addCompanyStyleCancel" footer=''>
			<a-form :form="form">
				<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="商会动态标题">
					<a-input v-decorator="['title', { rules: [{ required: true, message: '请输入商会动态标题' }] }]" placeholder="请输入商会动态标题" />
				</a-form-item>
				<a-form-item  :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="封面">
					
					<el-upload
						list-type="picture-card"
						:action="domain"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccess"
						:before-upload="beforeAvatarUpload"
						:limit="1"
						multiple
						:on-exceed="handleExceed"
						:file-list="bannerList"
					>
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">
								封面(1张)
							</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="bannerRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible"><img width="70%" :src="dialogImageUrl" alt="" /></el-dialog>
					
				</a-form-item>
				<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 15 }" label="商会动态简介">
					<a-textarea 
						v-decorator="['intro', { rules: [{ required: true, message: '请输入商会动态简介' }] }]"
						placeholder="请输入商会动态简介" :rows="7" />
				</a-form-item>
				
				<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" label="商会详情图片">
					<el-upload
						list-type="picture-card"
						:action="domain"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccessImg"
						:before-upload="beforeAvatarUpload"
						:limit="15"
						multiple
						:on-exceed="handleExceed"
						:file-list="imgList"
					>
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">
								详情图片
							</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="bannerRemoveDetail(file)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
						</div>
					</el-upload>
				</a-form-item>
				
				<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
					<a-button type="primary" @click="handleSubmit">
						保存
					</a-button>
				</a-form-item>
			</a-form>
		</a-modal>
	</div>
</template>

<script>
	import E from 'wangeditor';
	import axios from 'axios'
	import api from '../../api/Api.js';
	export default {
		 name: "WriteArticle",
		data() {
			return { 
				detail:'',
				Title:'',
				Content:'',
				editInput:'123123123',
				menu: '商会动态',
				addCompanyStyleWindow: false,
				addCompanyStyleLoading: false,
				form: this.$form.createForm(this, { name: 'dynamic_rule' }),
				imageUrl: '',
				QiniuData: {
					key: "", //图片名字处理
					token: "" //七牛云token
				},
				domain: "https://upload-z2.qiniup.com", // 七牛云的上传地址（华南区）
				qiniuaddr: "http://cdn.diqwl.com", // 七牛云的图片外链地址
				pictureAddress: '',
				bannerList: [],
				imgList:[],
				page:0,
				dynamicList:[],
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				pagination: {
					onChange: page => {
						console.log(page);
					},
					pageSize: 5
				}
			};
		},
		mounted() {
			this.getQiniuToken()
			this.getDynamicList()
		},
		methods: {
			handleSubmit () {
				const that = this;
						
				this.$confirm({
					title: '确定保存吗？',
					content: '点击保存之后，您的数据将会即刻更改，谨慎操作！',
					onOk() {
						if (that.checkUrl()) {
							that.$message.error('图片信息不完善！');
							return;
						}
						const bannerList = [];
						const imgList = [];
						that.bannerList.forEach((item, index, array) => {
							bannerList.push(item.url);
						});
						that.imgList.forEach((item, index, array) => {
							imgList.push(item.url);
						});
						
						that.form.validateFields((err, values) => {
							if (!err) {
								values.establishDate = that.establishDate;
								that.data = {
									title:values.title,
									cover: bannerList,
									img: imgList,
									intro: values.intro
								};
								that.addDynamic();
							}
						
							return new Promise((resolve, reject) => {
								setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
							}).catch(() => console.log('Oops errors!'));
						});
					},
					onCancel() {
						that.$message.warning('你点击了取消');
					}
				});
			},
			addDynamic(){
				
				var that = this;
				
				let url = 'api/commerce/v1/admin/addDynamic';
				let parm = this.data;
			
				api.postRequest(url, parm, res => {
					const rest = res.data;
					if (rest.status == 200) {
						
						that.addCompanyStyleWindow = false;
						that.getDynamicList();
						that.resetForm();
						that.$message.success('添加成功！');
					} else {
						that.$message.error('服务器内部错误！');
					}
				});
			},
			getDynamicList(){
				const that = this;
				let url = 'api/commerce/v1/admin/dynamicList';
				let parm = {
					page: this.page
				};
						
				api.postRequest(url, parm, res => {
					console.log(res);
						
					const rest = res.data;
					if (rest.status == 200) {
						
						that.dynamicList = rest.data;
						console.log("=====================")
						console.log(that.dynamicList)
						console.log("=====================")
						
					} else {
						this.$message.error('服务器内部错误！');
					}
				});
				
			},
			resetForm() {
				
				this.form.resetFields();
				
				this.bannerList = []
				this.imgList = []
			},
			checkUrl() {
				if (this.bannerList.length == 0 || this.imgList.length == 0) {
					return true;
				}
				return false;
			},
			bannerRemove(file) {
				var index = this.bannerList.findIndex(item => {
					if (item.uid == file.uid) {
						return true;
					}
				});
				this.bannerList.splice(index, 1);
			},
			beforeAvatarUpload(file) {
				const isPNG = file.type === 'image/png';
				const isJPEG = file.type === 'image/jpeg';
				const isJPG = file.type === 'image/jpg';
				const isLt2M = file.size / 1024 / 1024 < 2;
			
				if (!isPNG && !isJPEG && !isJPG) {
					this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
					return false;
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
					return false;
				}
				this.QiniuData.key = `store_banner_${file.name}`;
				this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
			},
			bannerRemoveDetail(file){
				var index = this.imgList.findIndex(item =>{
				if(item.uid==file.uid){
					return true
				}
			})
				console.log(index)
				this.bannerList.splice(index,1)
			},
			showAddStyleModal(){
				this.addCompanyStyleWindow = true;
			},
			showCommodityModal(item) {
				this.addCompanyStyleWindow = true;
			},
			addCommodityOk() {
				console.log(this.form.getFieldsValue());
				this.form.validateFields(err => {
					if (!err) {
						console.info('success');
					} else {
						return;
					}
				});
				this.ModalText = 'The modal will be closed after two seconds';
				this.addMenuLoading = true;
				setTimeout(() => {
					this.addCompanyStyleWindow = false;
					this.addCompanyStyleLoading = false;
				}, 1000);
			},
			addCompanyStyleCancel() {
				this.addCompanyStyleWindow = false;
			},
			commodityMoney(value) {
				console.log(value);
			},
			handleChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					// Get this url from response in real world.
					getBase64(info.file.originFileObj, imageUrl => {
						this.imageUrl = imageUrl;
						this.loading = false;
					});
				}
			},
			beforeUpload(file) {
				const isPNG = file.type === "image/png";
				const isJPEG = file.type === "image/jpeg";
				const isJPG = file.type === "image/jpg";
				const isLt2M = file.size / 1024 / 1024 < 2;
						
				if (!isPNG && !isJPEG && !isJPG) {
				  this.$message.error("上传头像图片只能是 jpg、png、jpeg 格式!");
				  return false;
				}
				if (!isLt2M) {
				  this.$message.error("上传头像图片大小不能超过 2MB!");
				  return false;
				}
				this.QiniuData.key = `store_banner_${file.name}`;
				this.pictureAddress = this.qiniuaddr +"/"+ this.QiniuData.key;
			},
			handlePreview(file) {
				this.previewImage = file.url || file.thumbUrl;
				this.previewVisible = true;
			},
			deleteDynamic(id){
				const that = this;
				let url = 'api/commerce/v1/admin/deleteDynamic';
				let parm = {
					id: id
				};
				api.postRequest(url, parm, res => {
					const rest = res.data;
					if (rest.status == 200) {
						this.$message.success('删除成功！');
						that.getDynamicList()
					} else {
						this.$message.error('服务器内部错误！');
					}
				});
			},
			uploadSuccess(response, file, fileList) {
				this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
				var obj = {
					status: 'done'
				};
				obj.uid = file.uid;
				obj.name = this.QiniuData.key;
				obj.url = this.pictureAddress;
				this.bannerList.push(obj);
			},
			uploadSuccessImg(response, file, fileList) {
				this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
				var obj = {
					status: 'done'
				};
				obj.uid = file.uid;
				obj.name = this.QiniuData.key;
				obj.url = this.pictureAddress;
				this.imgList.push(obj);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleExceed(files, fileList) {
				this.$message.warning(`图片选择已上限，如需更换，请删除上一张图片在重新选择！`);
			},
			//请求后台拿七牛云token
			getQiniuToken() {
				axios({
					method: 'post',
					url: '/api/file/v1/qiniu/getToken',
					data: JSON.stringify({
						param: '1'
					}),
					headers: {
						"authCode":'GJaImrLgzbgKQ0GaNX5kgCDtPrk7mcdF6Kq2zxe62pU=',
						'Content-Type': 'application/json',
						token: localStorage.getItem('accessToken'),
						"device": 'admin'
					}
				}).then(res => {
					if (res.data.status == 200) {
						this.QiniuData.token = res.data.data.token;
					} else {
						this.$message.error('服务器内部错误');
					}
				});
			},
			uploadError(err, file, fileList) {
				this.$message({
					message: '上传出错，请重试！',
					type: 'error',
					center: true
				});
			},
			cancel(){
				
			}
		}
	};
</script>

<style>
	.banner-title {
		border-bottom: 2px solid gray;
		margin-bottom: 30px;
		margin-top: 10px;
	}
	.preview_phone {
		width: 670px;
		height: 670px;
		background-image: url('../../static/phone.png');
		background-size: 100%;
	}
</style>
